import { ApiHttpError } from '@/api/client';

/** User-facing copy for known league API `error.code` values (crowdfpl-server `leagues.handlers`). */
export const LEAGUE_API_ERROR_MESSAGES = {
  LEAGUE_PRIVATE: 'This league is private',
  NOT_OWNER: 'Only the league owner can do that',
  LEAGUE_FULL: 'This league is full (100 members)',
  INVITE_INVALID: 'That invite code does not match any league',
  OWNER_CANNOT_LEAVE: 'League owners cannot leave — delete the league instead',
  NOT_A_MEMBER: 'You are not a member of this league',
  CANNOT_REMOVE_OWNER: 'You cannot remove the league owner',
} as const satisfies Record<string, string>;

export type LeagueApiErrorCode = keyof typeof LEAGUE_API_ERROR_MESSAGES;

export function getLeagueApiUserToastMessage(error: unknown): string {
  if (error instanceof ApiHttpError) {
    if (error.status === 429) {
      return error.message || 'Too many requests. Please wait and try again.';
    }
    const code = error.code;
    if (code && code in LEAGUE_API_ERROR_MESSAGES) {
      return LEAGUE_API_ERROR_MESSAGES[code as LeagueApiErrorCode];
    }
    return error.message || 'Something went wrong';
  }
  if (error instanceof Error) return error.message;
  return 'Something went wrong';
}

/** Inline field errors for join-by-code flows (modal). Other errors use toast via `getLeagueApiUserToastMessage`. */
export function getLeagueJoinByCodeInlineError(error: unknown): string | null {
  if (!(error instanceof ApiHttpError)) return null;
  if (error.code === 'INVITE_INVALID') return LEAGUE_API_ERROR_MESSAGES.INVITE_INVALID;
  if (error.code === 'LEAGUE_FULL') return LEAGUE_API_ERROR_MESSAGES.LEAGUE_FULL;
  return null;
}
